import { render, staticRenderFns } from "./AggregateOrdersPane.vue?vue&type=template&id=347ca7b8"
import script from "./AggregateOrdersPane.vue?vue&type=script&lang=js"
export * from "./AggregateOrdersPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports